import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './About.css';

const About: React.FC = () => {
  const { t } = useLanguage();
  return (
    <section id="about" className="about section" role="region" aria-labelledby="about-title">
      <div className="container">
        <div className="about-content">
          <div className="about-text">
            <h2 id="about-title" className="section-title">{t('about.title')}</h2>
            <p className="about-description">
              {t('about.description.part1')}
            </p>
            <p className="about-description">
              {t('about.description.part2')}
            </p>
          </div>

          <div className="about-features">
            <article className="feature-card">
              <div className="feature-icon">
                <img src="/delivery-truck.png" alt="Transport and pickup services" />
              </div>
              <h3 className="feature-title">{t('about.features.pickupService.title')}</h3>
              <p className="feature-description">
                {t('about.features.pickupService.description')}
              </p>
            </article>

            <article className="feature-card">
              <div className="feature-icon">
                <img src="/phone.png" alt="Easy contact and selling process" />
              </div>
              <h3 className="feature-title">{t('about.features.easySelling.title')}</h3>
              <p className="feature-description">
                {t('about.features.easySelling.description')}
              </p>
            </article>

            <article className="feature-card">
              <div className="feature-icon">
                <img src="/cooperation.png" alt="Fair prices and reliable service" />
              </div>
              <h3 className="feature-title">{t('about.features.fairPrices.title')}</h3>
              <p className="feature-description">
                {t('about.features.fairPrices.description')}
              </p>
            </article>
          </div>

          <div className="about-stats">
            <div className="about-stat">
              <span className="about-stat-number">{t('about.stats.allParts.number')}</span>
              <span className="about-stat-label">{t('about.stats.allParts.label')}</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-number">{t('about.stats.countries.number')}</span>
              <span className="about-stat-label">{t('about.stats.countries.label')}</span>
            </div>
            <div className="about-stat">
              <span className="about-stat-number">{t('about.stats.ownTransport.number')}</span>
              <span className="about-stat-label">{t('about.stats.ownTransport.label')}</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
